import { useState } from 'react';
import { useCurrentCompany } from '../../../hooks/useCompany';
import { DateField } from '../../../components/form/input/DateField';
import { addMonths, endOfMonth, format, startOfMonth } from 'date-fns';
import { useLoading } from '../../../context/loadingContext';
import { onDownloadItem } from '../../../utils/functions/file.functions';
import { apiUrl } from '../../../api/apiUrl';
import Button from '../../../components/button/Button';
import { dateSubmitFormat } from '../../../types/core/date.types';
import { useTranslation } from '../../../context/translationContext';

interface FilterExport {
  from: Date | null;
  to: Date | null;
}

/**
 * Page component represents list of Invoices for current company
 */
export const IssuedDocumentsExport = () => {
  const { t } = useTranslation();
  const { company } = useCurrentCompany();
  const { startLoading, stopLoading } = useLoading();
  const [filter, setFilter] = useState<FilterExport>({
    from: startOfMonth(addMonths(new Date(), -1)),
    to: endOfMonth(addMonths(new Date(), -1)),
  });

  const onSubmit = () => {
    if (!company || !filter.from || !filter.to) return;
    startLoading();
    const req = `?companyId=${company?.id}&from=${format(
      filter?.from,
      dateSubmitFormat,
    )}&to=${format(filter?.to, dateSubmitFormat)}`;
    onDownloadItem(`${apiUrl.ISSUED_DOCUMENTS_EXPORT}${req}`, `IssuedDocumentsExport.xlsx`).then(
      () => stopLoading(),
    );
  };

  return (
    <>
      <h1 className="text-3xl font-bold">{t('page.issued-document-export.headline')}</h1>
      <div className="flex w-1/3">
        <div className="mr-5">
          <DateField
            handleChange={(e) => setFilter({ ...filter, from: e })}
            placeholder={t('page.issued-document-export.from')}
            title={t('page.issued-document-export.from')}
            type={'Date'}
            value={filter?.from ?? new Date()}
            showClearButton={false}
          />
        </div>
        <div className="mr-5">
          <DateField
            handleChange={(e) => setFilter({ ...filter, to: e })}
            placeholder={t('page.issued-document-export.to')}
            title={t('page.issued-document-export.to')}
            type={'Date'}
            value={filter?.to ?? new Date()}
            showClearButton={false}
          />
        </div>
      </div>
      <Button color={'blue'} title={'Download'} onClick={onSubmit} showLoading />
    </>
  );
};
